import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
  selector: 'cmi-login-dialog',
  imports: [],
  template: ''
})
export class LoginDialog implements OnInit {
  private readonly _authService = inject(AuthService);
  private readonly _route = inject(ActivatedRoute);

  public ngOnInit(): void {
    const sts = this._route.snapshot.queryParamMap.get('sts');
    void this._authService.signIn(sts ?? undefined);
  }
}
